<template>
  <div class="flex flex-col w-full items-center pt-2">
    <YoutubeComponent></YoutubeComponent>
    <div class="pt-20 lg:pt-28"></div>
  </div>
</template>

<script setup lang="ts">
import YoutubeComponent from "../components/youtube_component.vue";
import { useHead } from "@vueuse/head";

useHead({
  title: "YouTube Transcription - Subtitles Tech",
});
</script>
